import { render, staticRenderFns } from "./CoinCodeInputArea.vue?vue&type=template&id=915e40ba&"
import script from "./CoinCodeInputArea.vue?vue&type=script&lang=ts&"
export * from "./CoinCodeInputArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports